<template>
  <div>
    <div class="banner">
      <p class="p-14" style="margin-top:67px">COPYRIGHT</p>
      <p class="p-30">关于版权家</p>
      <p style="font-weight:400;letter-spacing:12px;color:#1C1C1C">确权/维权/交易</p>
    </div>
    <div class="img-box">
      <div style="margin-left:32px;">
        <p class="p-18">COPYRIGHT</p>
        <p class="p-25" style="margin:10px 0px 20px;">北京版全家科技发展有限公司</p>
        <p class="p14">北京版全家科技发展有限公司（以下简称版权家）是厦门安妮</p>
        <p class="p14">股份有限公司（股票代码：002235）的全资子公司，致力于</p>
        <p class="p14" style="margin-bottom:25px;">发展数字版权服务市场。</p>
        <p class="p14" style="font-weight:bold;">版权家是中国版权保护中心战略合作伙伴，</p>
        <p class="p14" style="font-weight:bold;">已累积版权服务5,000,000+次。</p>
      </div>
      <div style="height:320px;position:relative;margin-right:45px">
        <img src="./images/icon1.png" alt='版权登记'/>
        <img src="./images/jiantou.png" class="position-img" style="left:-25px;" alt='版权登记'/>
      </div>
    </div>
    <div class="black-box">
      <p class="p-18" style="color:rgba(255,255,255,1);margin:60px 0px 10px">BUSINESS</p>
      <p class="p-25" style="color:rgba(255,255,255,1);margin-bottom:20px">我们的业务</p>
      <p class="p14" style="color:rgba(255,255,255,1);">版权家将一直致力于为用户提供快捷、便利的线上版权服务，</p>
      <p class="p14" style="color:rgba(255,255,255,1);">帮助著作人实现极速存证、登记、监测、取证、维权服务，为广大版</p>
      <p class="p14" style="color:rgba(255,255,255,1);">权人提供更专业、更高效的版权服务线上体验。</p>
      <div class="img-group">
        <ul>
          <li>
            <img src="./images/img1.png" alt='版权登记'/>
            <p>存证</p>
          </li>
          <li>
            <img src="./images/img2.png" alt='版权登记'/>
            <p>登记</p>
          </li>
          <li>
            <img src="./images/img3.png" alt='版权登记'/>
            <p>监测</p>
          </li>
          <li>
            <img src="./images/img4.png" alt='版权登记'/>
            <p>取证</p>
          </li>
          <li style="margin-right:0px">
            <img src="./images/img5.png" alt='版权登记'/>
            <p>维权</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="img-box" style="margin-bottom:98px;">
       <div style="height:320px;position:relative;margin-left:32px;">
        <img src="./images/icon2.png" alt='版权登记'/>
        <img src="./images/jiantou2.png" class="position-img" style="right:-25px;" alt='版权登记'/>
      </div>
      <div style="margin-right:45px">
        <p class="p-18">TARGET</p>
        <p class="p-25" style="margin:10px 0px 20px;">全面拓展版权业务</p>
        <p class="p14">未来，版权家还将展开一系列多媒体内容运营与版权费结算的</p>
        <p class="p14">新服务，保护著作权人的相关权益和帮助著作权人实现作品版</p>
        <p class="p14" style="margin-bottom:25px;">权价值。</p>
        <p class="p14" style="font-weight:bold;">版权家将就音乐、新媒体、网络文学和图片等领域的行业政</p>
        <p class="p14" style="font-weight:bold;">策、技术创新、版权保护和版权费结算进行业务延展。</p>
      </div>
    </div>
<!--    <div class="about-bottom">
      <div class="float-dox">
        <div class="left-img">
          <p class="p-18" style="margin:36px 0px 10px 42px">CONTACT US</p>
          <p class="p-25" style="margin-bottom:10px;">联系我们</p>
          <p class="p-new14">北京版全家科技发展有限公司</p>
          <p class="p-new14">北京市海淀区京玺文化创意创新园A16栋D座</p>
          <p class="p-new14">客服电话：17316071137，17316071136</p>
        </div>
        <div class="right-img">
          &lt;!&ndash; <img src="./images/map.png" alt='版权登记'/> &ndash;&gt;
          <div class="map" style="width:920px;height:330px;" id="myMap"></div>
        </div>
      </div>
    </div>-->

  </div>
</template>

<script>
export default {
  metaInfo: {
      title: '关于我们|版权服务专家|版权家',
      meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
      },{
          name: 'Description',
          content: '关于我们,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
      }]
  },
  name: "aboutUs",
  methods:{
    /*getMap(){
      let map = new BMap.Map("myMap");          // 创建地图实例
      // 116.336088,40.057519 116.506027,39.90859 116.336079,40.057554  116.336009,40.057029
      var point = new BMap.Point(116.336079, 40.057554);  // 创建点坐标  117.943155,24.584984
      map.centerAndZoom(point, 19);
      map.enableScrollWheelZoom(true);
      let marker = new BMap.Marker(point);        // 创建标注

      map.addOverlay(marker);
      let opts = {
        width : 250,     // 信息窗口宽度
        height: 120,     // 信息窗口高度
        title : "北京版全家科技发展有限公司"  // 信息窗口标题
      }
      let infoWindow = new BMap.InfoWindow("<p style='font-size:16px'>北京市海淀区京玺文化创意创新园A16栋D座</p>", opts);  // 创建信息窗口对象
      map.openInfoWindow(infoWindow, map.getCenter());      // 打开信息窗口
      marker.addEventListener("click",function(){
        marker.openInfoWindow(infoWindow, map.getCenter())
      })
      // 添加定位控件
      let geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMap.Size(20, 20)
      })
      geolocationControl.addEventListener("locationSuccess", function(e){
        map.panTo(new BMap.Point(116.336079, 40.057554));
      });
      geolocationControl.addEventListener("locationError",function(e){
        map.panTo(new BMap.Point(116.336079, 40.057554));
      });
      map.addControl(geolocationControl);
    }*/
  },
  mounted(){
    /*this.getMap()*/
  }
};
</script>
<style>
  #myMap .center{
  border-radius: 0px 0px 10px 10px;
    overflow: hidden;
    z-index: 1;
    position: absolute;
    left: 0px;
    top: 25px;
    width: 282px !important;
    height: 126px !important;
    box-shadow: none !important;
}
#myMap .bottom{
  height: 21px !important;
  border: none !important;
}
</style>
<style scoped lang="less">

.banner{
  height: 240px;
  background: url(./images/bg2x.png) no-repeat;
  background-position: center;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;
  .p-14{
    font-size:14px;
    font-weight:800;
    color:rgba(28,28,28,1);
    line-height:20px;
    letter-spacing:2px;
    margin:15px 0px 10px;
  }
  .p-30{
    font-size:30px;
    font-weight:bold;
    color:rgba(28,28,28,1);
    line-height:42px;
    letter-spacing:9px;
  }

}
.img-box{
  height: 320px;
  width:1334px;
  margin:50px auto 92px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img{
    width:570px;
    height:320px;
  }
  .position-img{
    position: absolute;
    width: 50px;
    height: 50px;
    top:135px;
  }
}
.p14{
  font-size:14px;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:26px;
  letter-spacing:1px;
}
.p-18{
  font-size:18px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:25px;
  letter-spacing:3px;
}
.p-25{
  font-size:25px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:34px;
  letter-spacing:10px;
}
.black-box{
  height: 446px;
  background:url(./images/bg4x.png) no-repeat;
  background-size:100% 100%;
  background-position: center;
  text-align: center;
  overflow: hidden;
  .img-group{
    height: 76px;
    ul{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top:55px;
    }
    ul li{
      height:76px;
      width:36px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction:column;
      margin-right: 85px;
      img{
        width:36px;
        height: 36px;
        margin-bottom: 10px;
      }
      p{
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:20px;
      }
    }
  }
}
.about-bottom{
  height: 306px;
  background:url(./images/bg5x.png) no-repeat;
  background-size:100% 100%;
  background-position: center;
  position: relative;
  .float-dox{
    width:1334px;
    margin:0 auto;
    height: 330px;
    position: absolute;
    top:60px;
    overflow: hidden;
    left:50%;
    transform: translate(-50%, -50%);
    div{
      float: left;
      height: 330px;
    }
    .left-img{
      width:413px;
      background:url(./images/fang.png) no-repeat;
      background-size:100% 100%;
      overflow: hidden;
      p{
        margin-left: 42px;
      }
    }
    .right-img{
      width:920px;
      img{
        width:920px;
        height: 330px;
      }
    }
  }
}
.p-new14{
  font-size:14px;
  font-weight:400;
  color:rgba(45,45,45,1);
  line-height:26px;
  letter-spacing:1px;
  margin-bottom: 10px;
}
</style>
